import { FluxStandardAction } from "__utils/type";
import * as Actions from "constants/actions";
import { SET_MANDATE_ACTIVATE_CONFIG } from '../../constants/actions';


export const fetchGetUserMandatesList = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_USER_MANDATES_LIST,
    }
};
export const fetchGetMandatesListSuccess = (mandatesList: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_USER_MANDATES_LIST_SUCCESS,
        payload: mandatesList
    }
};
export const fetchGetMandatesListFailure = (err: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_USER_MANDATES_LIST_FAILURE,
        payload: err
    }
};
export const storeMandateActivateConfig = (data: any): FluxStandardAction => {
    return {
        type: SET_MANDATE_ACTIVATE_CONFIG,
        payload: data
    }
};